import React from 'react';
import PropTypes from 'prop-types';

const ImportedFileMoreRows = ({
  importedFileHasMoreRowsThanGuests,
  moreRowsThanGuestsTitle,
  moreRowsThanGuestsInImportedFile,
  moreRowsThanGuestsInReservation,
}) => (
  <div className="imported-file-more-rows-container">
    <span>{moreRowsThanGuestsTitle}</span>
    <span>{moreRowsThanGuestsInImportedFile} {importedFileHasMoreRowsThanGuests.newGuests}</span>
    <span>{moreRowsThanGuestsInReservation} {importedFileHasMoreRowsThanGuests.anonymous}</span>
  </div>
);

ImportedFileMoreRows.propTypes = {
  importedFileHasMoreRowsThanGuests: PropTypes.object,
  moreRowsThanGuestsTitle: PropTypes.string,
  moreRowsThanGuestsInImportedFile: PropTypes.string,
  moreRowsThanGuestsInReservation: PropTypes.string,
};

export default ImportedFileMoreRows;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/blocks/importedFileMoreRows.js